import React, { useContext } from 'react';
import AuthContext from '../AuthContext';
import { Link } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner';

const Home = () => {
    const { user, loading } = useContext(AuthContext);

    if (loading) {
        return <LoadingSpinner />;
    }

    return (
        <div className="home-container">
            {!user && (
                <header className="hero-section">
                    <h1 className="hero-title">Welcome to Local Technician Finder</h1>
                    <p className="hero-subtitle">Your trusted platform to connect with skilled local technicians.</p>
                    <div className="cta-buttons">
                        <Link to="/technicians" className="btn">Find a Technician</Link>
                        <Link to="/register" className="btn btn-secondary">Become a Technician</Link>
                    </div>
                </header>
            )}

            {user && user.role === 'customer' && (
                <header className="hero-section">
                    <h1 className="hero-title">Hello, {user.username}!</h1>
                    <p className="hero-subtitle">Ready to find the perfect technician for your next project?</p>
                    <div className="cta-buttons">
                        <Link to="/technicians" className="btn">Browse Technicians</Link>
                        <Link to="/book" className="btn btn-secondary">Book a Service</Link>
                    </div>
                </header>
            )}

            {user && user.role === 'technician' && (
                <header className="hero-section">
                    <h1 className="hero-title">Welcome back, {user.username}!</h1>
                    <p className="hero-subtitle">Manage your profile, view your bookings, and grow your business.</p>
                    <div className="cta-buttons">
                        <Link to="/profile-form" className="btn">Manage My Profile</Link>
                        <Link to="/my-bookings" className="btn btn-secondary">View My Bookings</Link>
                    </div>
                </header>
            )}

            <section className="features-section">
                <h2>How It Works</h2>
                <div className="features-grid">
                    <div className="feature-card card">
                        <h3>1. Search</h3>
                        <p>Easily find technicians by service type, location, and ratings.</p>
                    </div>
                    <div className="feature-card card">
                        <h3>2. Book</h3>
                        <p>Request appointments directly through our platform.</p>
                    </div>
                    <div className="feature-card card">
                        <h3>3. Review</h3>
                        <p>Rate and review services to help others make informed decisions.</p>
                    </div>
                </div>
            </section>

            <section className="card">
                <h2>Why Choose Us?</h2>
                <ul className="list-group">
                    <li className="list-group-item"><strong>Local Experts:</strong> Connect with verified professionals in your area.</li>
                    <li className="list-group-item"><strong>Transparent Pricing:</strong> Clear hourly rates and service descriptions.</li>
                    <li className="list-group-item"><strong>Reliable Reviews:</strong> Real feedback from real customers.</li>
                    <li className="list-group-item"><strong>Convenient Booking:</strong> Schedule services at your fingertips.</li>
                </ul>
            </section>

            <section className="features-section">
                <h2>Popular Services</h2>
                <div className="features-grid">
                    <div className="feature-card card">
                        <h3>Plumbing</h3>
                        <p>Leaky faucets, clogged drains, water heater repair.</p>
                    </div>
                    <div className="feature-card card">
                        <h3>Electrical</h3>
                        <p>Wiring, outlet installation, circuit breaker issues.</p>
                    </div>
                    <div className="feature-card card">
                        <h3>IT Support</h3>
                        <p>Computer repair, network setup, software troubleshooting.</p>
                    </div>
                    <div className="feature-card card">
                        <h3>HVAC</h3>
                        <p>AC repair, furnace maintenance, duct cleaning.</p>
                    </div>
                </div>
            </section>

            <footer className="card">
                <p>&copy; {new Date().getFullYear()} Local Technician Finder. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default Home;